import * as Yup from 'yup';

export const PartnersSchema = Yup.object().shape({
	title: Yup.string().required('Veuillez renseigner un identifiant'),
	active: Yup.string().required('Veuillez renseigner un statut')
});